module.exports = __webpack_public_path__ + "img/fire.2f85543e.png";